import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import ZenSpinner from '../../components/ZenSpinner';
import AudioPlayerComponent from '../../components/AudioPlayerComponent';

const generateAudioURL = (meditationType, soundBackground, duration) => {
  const language = localStorage.getItem('i18nextLng') || 'fr';
  const sound = soundBackground ? 'soundtrue' : 'soundfalse';
  const fileName = `${language}/${language}-${meditationType}_${sound}_${duration}.aac`;
  return `https://data.heyraoul.fr/audios/timers/${fileName}`;
};

const AILivePage = () => {
  const { sessionId } = useParams();
  const navigate = useNavigate();
  const [meditationData, setMeditationData] = useState(null);

  useEffect(() => {
    const fetchMeditationDetails = async () => {
      try {
        const res = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/ai/session-history/${sessionId}`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`,
          },
        });

        const data = await res.json();

        if (res.ok && Array.isArray(data)) {
          const latestMeditation = [...data]
            .reverse()
            .find(m => m.context && typeof m.context.duration === 'number');

          if (latestMeditation) {
            setMeditationData({
              meetingId: latestMeditation._id,
              meditationType: latestMeditation.context.meditationType,
              soundBackground: latestMeditation.context.soundBackground,
              duration: latestMeditation.context.duration,
            });
          } else {
            console.warn('⚠️ Aucune méditation valide trouvée.');
          }
        } else {
          console.error('❌ Erreur chargement session', data.message);
        }
      } catch (err) {
        console.error('❌ Erreur fetch session', err);
      }
    };

    fetchMeditationDetails();
  }, [sessionId]);

  const handleEndMeditation = async () => {
    if (!meditationData?.meetingId) return;

    try {
      const res = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/ai/complete-meditation`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
        body: JSON.stringify({
          sessionId,
          meetingId: meditationData.meetingId,
        }),
      });

      if (res.ok) {
      } else {
        const data = await res.json();
        console.error('❌ Erreur completion méditation:', data.message);
        navigate(-1);
      }
    } catch (err) {
      console.error('❌ Exception completion méditation:', err);
      navigate(-1);
    } 
  };

  const handleCancelMeditation = async () => {
    if (!meditationData?.meetingId) return;

    try {
      const res = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/ai/cancel-meditation`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
        body: JSON.stringify({
          sessionId,
          meetingId: meditationData.meetingId,
        }),
      });

      if (res.ok) {
      } else {
        const data = await res.json();
        console.error('❌ Erreur annulation méditation:', data.message);
      }
    } catch (err) {
      console.error('❌ Exception annulation méditation:', err);
    } finally {
      navigate(-1);
    }
  };

  if (!meditationData) return <ZenSpinner />;

  const audioSrc = generateAudioURL(
    meditationData.meditationType,
    meditationData.soundBackground,
    meditationData.duration
  );

  return (
    <div style={{ textAlign: 'center', padding: '20px' }}>
      <AudioPlayerComponent
        audioSrc={audioSrc}
        title=""
        onClose={handleEndMeditation}
        onCancel={handleCancelMeditation}
      />
    </div>
  );
};

export default AILivePage;